var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePayIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 40,
    viewBox: "0 0 136 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6445_8070)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.83 40H5.83387C3.07715 40 0.832031 37.7456 0.832031 35V5C0.832031 2.24439 3.07715 0 5.83387 0H130.83C133.584 0 135.832 2.24439 135.832 5V35C135.832 37.7456 133.584 40 130.83 40Z",
    fill: "#061A3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.83 0.800499C133.142 0.800499 135.035 2.68828 135.035 5V35C135.035 37.3117 133.155 39.1995 130.83 39.1995H5.83387C3.5217 39.1995 1.62925 37.3117 1.62925 35V5C1.62925 2.68828 3.50928 0.800499 5.83387 0.800499H130.83ZM130.83 0H5.83387C3.07715 0 0.832031 2.25436 0.832031 5V35C0.832031 37.7556 3.07715 40 5.83387 40H130.83C133.584 40 135.832 37.7556 135.832 35V5C135.832 2.25436 133.584 0 130.83 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9504 13.2319C71.0489 13.2319 70.2889 12.9152 69.6879 12.2917C69.0918 11.6857 68.7591 10.8503 68.774 9.99745C68.774 9.08723 69.0819 8.31666 69.6879 7.70568C70.2864 7.08224 71.0464 6.76553 71.9479 6.76553C72.8395 6.76553 73.5994 7.08224 74.2104 7.70568C74.8164 8.33661 75.1243 9.10718 75.1243 9.99745C75.1144 10.9102 74.8064 11.6807 74.2104 12.2892C73.6119 12.9177 72.8519 13.2319 71.9504 13.2319ZM45.1259 13.2319C44.2442 13.2319 43.4793 12.9201 42.8535 12.3042C42.2326 11.6907 41.9172 10.9152 41.9172 9.99995C41.9172 9.08474 42.2326 8.30917 42.8535 7.69571C43.4669 7.07975 44.2318 6.76803 45.1259 6.76803C45.563 6.76803 45.9877 6.85531 46.395 7.03237C46.7948 7.20444 47.1201 7.43885 47.361 7.72563L47.4207 7.79795L46.7476 8.46129L46.6781 8.379C46.2981 7.92513 45.789 7.70319 45.1159 7.70319C44.5149 7.70319 43.9909 7.91765 43.5588 8.34159C43.1242 8.76803 42.9031 9.32663 42.9031 10.0024C42.9031 10.6783 43.1242 11.2369 43.5588 11.6633C43.9909 12.0872 44.5149 12.3017 45.1159 12.3017C45.7567 12.3017 46.2956 12.0872 46.7153 11.6633C46.9637 11.4139 47.1177 11.0648 47.1723 10.6234H45.0141V9.69072H48.0987L48.1111 9.77551C48.1334 9.93262 48.1558 10.0947 48.1558 10.2443C48.1558 11.1047 47.8975 11.8004 47.3859 12.3142C46.8047 12.9226 46.0448 13.2319 45.1259 13.2319ZM80.7917 13.0997H79.8405L76.9274 8.4189L76.9522 9.26179V13.0972H76.001V6.9002H77.0863L77.1161 6.94758L79.8554 11.3566L79.8306 10.5162V6.9002H80.7917V13.0997ZM64.8028 13.0997H63.8392V7.83287H62.1678V6.9002H66.4717V7.83287H64.8003V13.0997H64.8028ZM61.383 13.0997H60.4219V6.9002H61.383V13.0997ZM55.9813 13.0997H55.0202V7.83287H53.3488V6.9002H57.6528V7.83287H55.9813V13.0997ZM52.7404 13.0897H49.0548V6.9002H52.7404V7.83287H50.0184V9.53361H52.4746V10.4563H50.0184V12.1571H52.7404V13.0897ZM70.3932 11.6508C70.8229 12.0822 71.3444 12.2992 71.9504 12.2992C72.5737 12.2992 73.0829 12.0872 73.5075 11.6508C73.9297 11.2269 74.1433 10.6708 74.1433 9.99995C74.1433 9.32912 73.9297 8.77052 73.51 8.34907C73.0804 7.91765 72.5564 7.7007 71.9529 7.7007C71.3295 7.7007 70.8204 7.91267 70.3982 8.34907C69.976 8.77301 69.7624 9.32912 69.7624 9.99995C69.7624 10.6708 69.9735 11.2294 70.3932 11.6508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6846 21.7556C66.3377 21.7556 64.4353 23.5436 64.4353 26.01C64.4353 28.4539 66.3501 30.2643 68.6846 30.2643C71.0315 30.2643 72.9339 28.4638 72.9339 26.01C72.9339 23.5436 71.0315 21.7556 68.6846 21.7556ZM68.6846 28.5785C67.4006 28.5785 66.2954 27.5112 66.2954 26C66.2954 24.4663 67.4031 23.4214 68.6846 23.4214C69.9686 23.4214 71.0738 24.4663 71.0738 26C71.0762 27.5212 69.9686 28.5785 68.6846 28.5785ZM59.4136 21.7556C57.0666 21.7556 55.1642 23.5436 55.1642 26.01C55.1642 28.4539 57.079 30.2643 59.4136 30.2643C61.7605 30.2643 63.6629 28.4638 63.6629 26.01C63.6629 23.5436 61.758 21.7556 59.4136 21.7556ZM59.4136 28.5785C58.1296 28.5785 57.0244 27.5112 57.0244 26C57.0244 24.4663 58.132 23.4214 59.4136 23.4214C60.6975 23.4214 61.8027 24.4663 61.8027 26C61.8027 27.5212 60.6975 28.5785 59.4136 28.5785ZM48.3817 23.0549V24.8554H52.6856C52.554 25.8653 52.2212 26.611 51.7121 27.1222C51.0813 27.7556 50.1077 28.4439 48.3916 28.4439C45.7466 28.4439 43.6778 26.2992 43.6778 23.6434C43.6778 20.9875 45.7466 18.8429 48.3916 18.8429C49.8196 18.8429 50.8602 19.409 51.6326 20.1322L52.9042 18.8554C51.8313 17.8229 50.4033 17.0324 48.4015 17.0324C44.7731 17.0324 41.7283 20 41.7283 23.6334C41.7283 27.2768 44.7706 30.2344 48.4015 30.2344C50.3611 30.2344 51.8313 29.591 52.9936 28.379C54.1783 27.1895 54.5533 25.5112 54.5533 24.1571C54.5533 23.7357 54.521 23.3566 54.4539 23.0349H48.3792C48.3817 23.0324 48.3817 23.0549 48.3817 23.0549ZM93.5051 24.4563C93.1499 23.5012 92.077 21.7456 89.8766 21.7456C87.6961 21.7456 85.8831 23.4688 85.8831 26C85.8831 28.389 87.6762 30.2544 90.0877 30.2544C92.0249 30.2544 93.1524 29.0648 93.6168 28.3666L92.1789 27.399C91.702 28.1097 91.0389 28.576 90.0977 28.576C89.1465 28.576 88.4809 28.1421 88.0388 27.2868L93.7038 24.9302C93.7038 24.9327 93.5051 24.4563 93.5051 24.4563ZM87.7284 25.8778C87.6837 24.2344 88.9999 23.399 89.9412 23.399C90.6838 23.399 91.3022 23.7656 91.5133 24.2992L87.7284 25.8778ZM83.1264 30H84.9865V17.5012H83.1264V30ZM80.0716 22.7007H80.0046C79.5848 22.1995 78.7876 21.7456 77.7694 21.7456C75.6559 21.7456 73.7088 23.6135 73.7088 26.0125C73.7088 28.4015 75.646 30.2469 77.7694 30.2469C78.7752 30.2469 79.5848 29.7905 80.0046 29.2793H80.0716V29.8903C80.0716 31.5137 79.2073 32.389 77.8141 32.389C76.6741 32.389 75.9663 31.5661 75.6782 30.8778L74.0615 31.5561C74.5259 32.6783 75.7652 34.0673 77.8116 34.0673C79.9921 34.0673 81.8399 32.778 81.8399 29.6334V22H80.0816V22.7007C80.084 22.7007 80.0716 22.7007 80.0716 22.7007ZM77.9358 28.5785C76.6518 28.5785 75.5789 27.5012 75.5789 26.0125C75.5789 24.5112 76.6518 23.4239 77.9358 23.4239C79.2074 23.4239 80.1933 24.5237 80.1933 26.0125C80.2057 27.5012 79.2098 28.5785 77.9358 28.5785ZM102.215 17.5012H97.7668V30H99.627V25.2668H102.217C104.276 25.2668 106.3 23.7681 106.3 21.389C106.3 19.01 104.284 17.5012 102.215 17.5012ZM102.269 23.5212H99.6245V19.2319H102.269C103.663 19.2319 104.45 20.3865 104.45 21.3765C104.45 22.3566 103.653 23.5212 102.269 23.5212ZM113.756 21.7332C112.405 21.7332 111.012 22.3342 110.435 23.6434L112.084 24.3317C112.44 23.6434 113.09 23.409 113.778 23.409C114.742 23.409 115.715 23.9875 115.738 25.0199V25.1521C115.405 24.9626 114.675 24.6733 113.801 24.6733C112.02 24.6733 110.214 25.6509 110.214 27.4838C110.214 29.1621 111.675 30.2394 113.301 30.2394C114.551 30.2394 115.239 29.6733 115.668 29.0174H115.735V29.985H117.528V25.197C117.528 22.9676 115.879 21.7332 113.756 21.7332ZM113.522 28.5785C112.914 28.5785 112.062 28.2793 112.062 27.5112C112.062 26.5436 113.125 26.177 114.032 26.177C114.851 26.177 115.239 26.3541 115.725 26.5985C115.591 27.7207 114.647 28.5686 113.522 28.5785ZM124.07 22L121.934 27.4214H121.867L119.654 22H117.653L120.973 29.5785L119.081 33.7905H121.018L126.126 22H124.07ZM107.326 30H109.186V17.5012H107.326V30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2232 7.53364C10.9351 7.84536 10.7687 8.32167 10.7687 8.94511V31.0573C10.7687 31.6808 10.9351 32.1571 11.2331 32.4563L11.3101 32.5237L23.6483 20.1346V19.8578L11.3002 7.46631L11.2232 7.53364Z",
    fill: "url(#paint0_linear_6445_8070)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7535 24.2768L23.6382 20.1447V19.8554L27.7535 15.7232L27.8429 15.7781L32.7106 18.5561C34.1039 19.3442 34.1039 20.6459 32.7106 21.4439L27.8429 24.222L27.7535 24.2768Z",
    fill: "url(#paint1_linear_6445_8070)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8429 24.2219L23.6383 20L11.2231 32.4663C11.6776 32.9551 12.44 33.01 13.2919 32.5337L27.8429 24.2219Z",
    fill: "url(#paint2_linear_6445_8070)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8429 15.7781L13.2919 7.47882C12.44 6.99004 11.6751 7.05737 11.2231 7.54615L23.6383 20L27.8429 15.7781Z",
    fill: "url(#paint3_linear_6445_8070)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7535 24.1322L13.3018 32.3766C12.4946 32.8429 11.7744 32.8105 11.31 32.3866L11.233 32.4639L11.31 32.5312C11.7744 32.9527 12.4946 32.9876 13.3018 32.5212L27.8529 24.222L27.7535 24.1322Z",
    fill: "#061A3A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7107 21.2993L27.7411 24.1322L27.8306 24.2219L32.6983 21.4439C33.3962 21.0449 33.7389 20.5212 33.7389 20C33.6967 20.4788 33.3415 20.9327 32.7107 21.2993Z",
    fill: "#061A3A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2919 7.62348L32.7107 18.7008C33.3415 19.0574 33.6967 19.5237 33.7513 20C33.7513 19.4788 33.4086 18.9551 32.7107 18.5561L13.2919 7.47884C11.8987 6.67834 10.7687 7.34667 10.7687 8.94517V9.08981C10.7687 7.48881 11.8987 6.83295 13.2919 7.62348Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6445_8070",
    x1: 22.5416,
    y1: 8.70654,
    x2: 2.76717,
    y2: 13.9538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6445_8070",
    x1: 34.5276,
    y1: 20.0001,
    x2: 10.4299,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6445_8070",
    x1: 25.5566,
    y1: 22.2973,
    x2: 9.59382,
    y2: 49.0538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6445_8070",
    x1: 8.0968,
    y1: 0.178805,
    x2: 15.2185,
    y2: 12.1287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6445_8070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    fill: "white",
    transform: "translate(0.832031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePayIc);
export default __webpack_public_path__ + "static/media/google-pay-ic.00fbce4e643678624bef320a006e7253.svg";
export { ForwardRef as ReactComponent };